

export function formatedDate(d) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let newDate = new Date(d)
    return newDate.getDate() + " " + monthNames[newDate.getMonth()] + " " + newDate.getUTCFullYear();
}